import { Line } from 'libraries/Line';
import { FontsService } from 'services/fonts/fonts.service';
import { Fonts } from 'domain-models/Fonts';
import { Component } from '@angular/core';

/**
 * Page class contains information about the lines on a sign.
 */
export class Page {
	lines: Array<Line>;
	flashOn: number = 2.0;
	flashOff: number = 0.0;
	font: Fonts;
	justification: number;
	imageResource: string;

	/**
	 * Constructor for Page Class
	 * @param numberLines Is the number of lines that a page will have, default value is 3
	 * @param pageNumber This is a number that is gonna be shown as the title for this page
	 */
	constructor(numberLines: number = 3, public pageNumber: number = 0) {
		this.lines = new Array<Line>(numberLines);
		for (var i = 0; i < this.lines.length; i++) {
			this.lines[i] = new Line();
			this.lines[i].text = '';
		}
	}

	// In my opinion, there is little need for these,
	//  as pageNumber in the constructor is already set as public
	get PageNumber() {
		return this.pageNumber;
	}
	set PageNumber(value: number) {
		this.pageNumber = value;
	}

	IsEmpty(): boolean {
		var result = true;
		this.lines.forEach((line) => {
			if (
				line.text != '' ||
				line.justifications[2] ||
				line.justifications[3] ||
				line.justifications[4]
			) {
				result = false;
			}
		});
		return result;
	}

	setFont(id: number, fontsService: FontsService) {
		// Manipulate font based on this id
		fontsService.getByValue(`${id}`, '').subscribe((result) => {
			// TODO: Figure out if we need to somehow wait for the subscription to resolve (since it's asynchronous)
			// Maybe return a Promise?
			this.font = result[0];
		});
	}

	setJustification(justification: number) {
		// Set justification based on this number
		this.justification = justification;
	}

	// set Flash(value: number) {
	//         console.log(value);
	//         this.flashOn=value;
	// }
	// get Flash() {
	//         return this.flashOn;
	// }
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/libraries/Page.ts